import { useState } from "react";
import FocusActionModal from "@/components/mirror/FocusActionModal";
import { newFocusOperationId, type FocusActionPrefill, type MirrorFocusReceiptReference } from "@/lib/focusExecutor";

export interface FocusPrefill {
  task: string; duration_minutes: number; source: "voice" | "manual" | "mirror";
  client_action_id?: string; transcriptRaw?: string | null;
  expected_user_id?: string; expected_session_id?: string; action_id?: string;
  operation_id?: string; focus_session_id?: string;
}
interface Props { open: boolean; prefill: FocusPrefill | null; onClose: () => void; onCreated: (receipt?: MirrorFocusReceiptReference) => void | Promise<boolean> }
/** Compatibility for reported voice sessions; the reviewed writer owns persistence. */
export default function FocusLogModal({ open, prefill, onClose, onCreated }: Props) {
  if (!open || !prefill) return null;
  return <ReportedFocus key={[prefill.operation_id, prefill.action_id, prefill.client_action_id, prefill.expected_user_id, prefill.expected_session_id].join(":")} prefill={prefill} onClose={onClose} onCreated={onCreated} />;
}
function ReportedFocus({ prefill, onClose, onCreated }: Omit<Props, "open" | "prefill"> & { prefill: FocusPrefill }) {
  const [operation] = useState(() => prefill.operation_id ?? newFocusOperationId());
  const actionId = prefill.action_id ?? prefill.client_action_id ?? "focus-report";
  const draft: FocusActionPrefill = { ...prefill, action: "create", action_id: actionId, operation_id: operation };
  return <FocusActionModal open prefill={draft} onClose={onClose} onCreated={onCreated} />;
}
